var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "130px",
    height: "130px",
    viewBox: "0 0 130 130",
    enableBackground: "new 0 0 130 130",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#BF8621",
    points: "9.507,32.883 65,64.922 65,129 9.507,96.96  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    fill: "#B77A18",
    points: "9.507,32.883 65,64.922 65,129  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#A87118",
    points: "120.493,32.883 65,64.922 65,129 120.493,96.96  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    fill: "#966215",
    points: "120.493,32.883 65,64.922 65,129  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#D39E35",
    points: "9.507,33.039 65,65.078 120.493,33.039 65,1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    fill: "#D39337",
    points: "9.507,33.039 65,65.078 120.493,33.039  "
  }))), /*#__PURE__*/React.createElement("polygon", {
    fill: "#D39337",
    points: "30.213,44.979 30.214,60.979 40.662,66.979 40.593,50.986  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "#E2A047",
    points: "40.593,50.986 30.213,44.979 30.214,60.979  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#EAB659",
    points: "30.213,44.957 44.07,36.958 54.49,43.006 40.605,50.942  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "#F7C961",
    points: "44.07,36.958 54.49,43.006 40.605,50.942  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#EAB659",
    points: "72.408,21.484 86.266,13.485 96.686,19.533 82.801,27.47  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "#F7C961",
    points: "86.266,13.485 96.686,19.533 82.801,27.47  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#1E1506",
    points: "75.24,102.995 75.287,115.003 85.714,109.022 85.714,97.042 89.142,95.021 80.463,86.813  71.783,104.979  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.84c57051a600d118ccb2ca04eff1e75f.svg";
export { ForwardRef as ReactComponent };